import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

function StartFirebase()
{
    const firebaseConfig = 
    {
        apiKey: "AIzaSyDHdY5Cwg8GSzk6PIm7W9ZKl48t3pAsDKg",
        authDomain: "valgraen-d68db.firebaseapp.com",
        databaseURL: "https://valgraen-d68db-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "valgraen-d68db",
        storageBucket: "valgraen-d68db.appspot.com",
        messagingSenderId: "870850004717",
        appId: "1:870850004717:web:1aca4cd252bf328b5e2ee4"
    }

    const app = initializeApp(firebaseConfig)
    return getDatabase(app)
}

export default StartFirebase